import { sendRequest } from "../../hooks/requests/useRequest";
import { ConfigServer } from '../../data/config';


export async function getAllClients (_type)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Company/ListTypeCompaniesMicro/${_type}?is_micro=true`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getInformationPatient (_id_patient,_uuid)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Patient/FindPatientId/${_id_patient}${_uuid}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getAllTypeSample (_type)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `TypeSamples/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getAllExam (_id_exam,_branch,_typeCommercialLine,_mIdPatient,_mIdClient,_alternative_method)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Exam/GetPriceFromExamMicro/${_id_exam},${_branch},${_typeCommercialLine},${_mIdPatient},${_mIdClient},0,true${_alternative_method}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getAllProfile (_id_exam,_branch,_typeCommercialLine,_mIdPatient,_mIdClient,_alternative_method)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Profiles/FindProfileIdMicro/${_id_exam},${_branch},${_typeCommercialLine},${_mIdPatient},${_mIdClient}?validation_strict=true&is_membership=false${_alternative_method}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}


export async function getAllRules (_type)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `CatNom/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}


export async function saveQuoter({
    id_company, id_patient,id_agreement, date_sample, is_sampling, id_branch, observations,list_type_samples,roleUser,id_address
}) {
    console.log("🚀 ~ saveQuoter ~ id_address:", id_address)

    var id_address_company = id_address === null ? null : id_address.value === 0 ? null :  id_address.id_address_company === undefined ? null : id_address.id_address_company
    var id_company_business_name = id_address === null ? null : id_address.value === 0 ? null : id_address.id_company_business_name === undefined ? null : id_address.id_company_business_name
 
    const body = {
        id_company,
        id_patient, 
        id_agreement,
        date_sample,
        is_sampling,
        id_branch, 
        observations,
        list_type_samples,
        roleUser,
        id_address_company,
        id_company_business_name
    };


    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations"
    );

    if (response.code === 200)
        return {
            code: response?.code ,
            codeQuoter: response?.data?.code,
            id_quoter: response?.data?.id_quoter
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            codeQuoter: response?.data?.code,
            id_quoter: response?.data?.id_quoter,
            code: response?.code ,

        };
}


export async function previewPdf({
    id_quoter, print_result, send_email, email_client, tax
}) {
    const body = {
        id_quoter,
        print_result,
        send_email,
        email_client,
        tax
    };

    let raw = JSON.stringify(body);
    let token = localStorage.getItem("token");

    const response = await fetch(
        ConfigServer.serverUrl + "/api/QuoterDeterminations/CreateDocumentQuoter",
        {
            method: 'POST',
            body: raw,
            headers: {
                "Authorization": "Bearer " + token,
                "Content-Type": "application/json"
            }
        }
    );

    if (response.status !== 200) {
        return { code: response.status };
    }

    const blob = await response.blob();
    return { code: 200, data: blob }; 
}

export async function dowloadPdf({ id_quoter, print_result, send_email, email_client, tax }) {
    try {
        const body = { id_quoter, print_result, send_email, email_client, tax };
        const raw = JSON.stringify(body);
        const token = localStorage.getItem("token");

        const response = await fetch(
            ConfigServer.serverUrl + "/api/QuoterDeterminations/CreateDocumentQuoter",
            {
                method: 'POST',
                body: raw,
                headers: {
                    "Authorization": "Bearer " + token,
                    "Content-Type": "application/json"
                }
            }
        );

        if (response.status !== 200) {
            return { code: response.status }; 
        }

        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "Cotizacion.pdf");
        document.body.appendChild(link);
        link.style.display = 'none';
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        return { code: 200 };
    } catch (error) {
        console.error(error);
        return { code: 500 }; 
    }
}


export async function getInformationQuatation (_code)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `QuoterDeterminations/FindQuoter/${_code}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function updateQuoter({
    id_company, id_patient, date_sample, is_sampling, id_branch, observations,list_type_samples,id_quoter,updatedatesample,id_address
}) {
    var id_address_company = id_address === null ? null : id_address.id_address_company === undefined ? null : id_address.id_address_company;
    var id_company_business_name = id_address === null ? null :   id_address.id_company_business_name === undefined ? null : id_address.id_company_business_name;

    const body = {
        id_company,
        id_patient, 
        date_sample,
        is_sampling,
        id_branch, 
        observations,
        list_type_samples,
        id_quoter,
        updatedatesample,
        id_address_company,
        id_company_business_name
    };
    console.log("🚀 ~ updateQuoter ~ body:", body)


    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "QuoterDeterminations/Update"
    );

    if (response.code === 200)
        return {
            code: response?.code ,
          
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            code: response?.code ,
        };
}

export async function getListQuatations (_query)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `QuoterDeterminations/FindQuoters?${_query}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function getInformationQuoterDeterminations (_code)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `QuoterDeterminations/DetailQuoter/${_code}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}


// ? CATALOGS NORM
export async function getAllCatalogsNorm (_type)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `CatNom/List`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}

export async function CreateCatalogs({
    name,
    description,
    estatus
}) {
    const body = {
        name,description,estatus
    };

    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "CatNom"
    );

    if (response.code === 200)
        return {
            code: response?.code ,
          
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
            response: response?.code ,

        };
}

export async function UpdateCatalogs({
    id_mic_nom ,name,description,estatus
}) {
  
    let body = {
        id_mic_nom:id_mic_nom,
        name:name,
        description:description,
        estatus:estatus
    };
    
    const requestOptions = {
        method: 'PUT',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, `CatNom/Update`
    );

    if (response.code === 200)
        return {
            code: response?.code ,
          
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
           
            response: response?.code ,

        };
}

export async function DeleteCatalogs({
    id_mic_nom  
}) {
  
    const requestOptions = {
        method: 'DELETE',
    };

    const response = await sendRequest(
        requestOptions, `CatNom/${id_mic_nom }`
    );

    if (response.code === 200)
        return {
            code: response?.code ,
          
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
           
            response: response?.code ,

        };
}

// ! CREATE PATIENT MICRO
export async function savePatientMicro({
    id_gender, id_state_patient,id_municipality_patient, id_social_gender_patient, id_blood_type, id_tax_regime, id_use_cfdi,paternal_surname,maternal_surname,
    name,birthday,age,curp,address_patient,cp_patient,colony_patient,phone,email_patient,membership,cardnumber,rfc,type_person,new_social_gender,scan_ine_check,
    setFileINE,nss,matricula_buap
}) {
    const body = {
        id_gender, id_state_patient,id_municipality_patient, id_social_gender_patient, id_blood_type, id_tax_regime, id_use_cfdi,paternal_surname,maternal_surname,
    name,birthday,age,curp,address_patient,cp_patient,colony_patient,phone,email_patient,membership,cardnumber,rfc,type_person,new_social_gender,scan_ine_check,
    setFileINE,nss,matricula_buap
    };


    const requestOptions = {
        method: 'POST',
        body: JSON.stringify(body)
    };

    const response = await sendRequest(
        requestOptions, "Patient"
    );

    if (response.code === 200)
        return {
            code: response?.code ,
        
        }
    else if (response.code === 401)
        return response.code;
    else
        return {
         
            code: response?.code ,

        };
}

// * NORM EXAM
export async function getAllRulesBiExam (_id_exam)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(requestOptions, `Exam/ListRuleByExam/${_id_exam}`);

    if (response.code === 200)
        return response.data;
    else 
        return response;
}


//* NORM PROFILES RULES

export async function getAllRulesByProfile(_id_profile)
{
    const requestOptions = {
        method: "GET",
    };

    const response = await sendRequest(
        requestOptions,
        `Profiles/ListRuleByProfile/${_id_profile}`
    );

    if (response.code === 200)
        return response.data;
    else
        return response;
}









